// emun data type license driver
import license from '@/data/driver/license.json'

export default {
  license
}
